import { render, staticRenderFns } from "./QnaMngt.vue?vue&type=template&id=193521b0"
import script from "./QnaMngt.vue?vue&type=script&lang=js"
export * from "./QnaMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports